import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { toggleOff } from '../../../styles/colors';
import { CssSelectors, Layouts } from '../../../styles/styles';

const itemSpacing = 8;

export const styleSheet = StyleSheet.create({
	container: {},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: THEME.spacing.sm,
	},
	headerLabel: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		fontWeight: THEME.typography.fontWeights.semibold,
		textTransform: 'uppercase',
		letterSpacing: '0.05em',
	},
	toggleRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	toggleLabel: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		cursor: 'pointer',
		userSelect: 'none',
	},
	content: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: itemSpacing,
	},
	error: {
		color: toggleOff,
		fontSize: 12,
		marginBottom: 6,
	},
	item: {
		...Layouts.horizontalStack(4),
		alignItems: 'center',
		background: THEME.colors.background.main,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box' as const,
		color: THEME.colors.text.main,
		display: 'inline-flex',
		fontSize: THEME.typography.fontSizes.xs,
		maxWidth: '80%',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		...CssSelectors.allChildren(
			{
				marginLeft: 6,
			},
			':last-child'
		),
	},
	itemError: {
		borderColor: THEME.colors.danger.main,
		background: 'rgba(208,2,27,0.05)', // no translucent-danger token in THEME; matches danger.main at 5% opacity
	},
	itemPending: {
		opacity: 0.7,
	},
	itemName: {
		color: THEME.colors.text.main,
		...THEME.common.truncate,
	},
	itemSize: {
		color: THEME.colors.text.light,
		flexShrink: 0,
		fontSize: THEME.typography.fontSizes.xs,
	},
	itemRemove: {
		height: 'auto',
		width: 'auto',
	},
	infoText: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		marginTop: THEME.spacing.xs,
		fontStyle: 'italic',
	},
});
